import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';

import { withStyles } from '../tools/withStyles';
import { Main } from '../components/Main';
import { Secuence } from '../components/Secuence';
import { Text } from '../components/Text';
import { Fader } from '../components/Fader';

const products = [
  {
    id: 114800,
    name: 'Meet & Greet + Foto, firma y Disco + VIP',
    lines: ['Meet & Greet', 'Foto, firma y disco + VIP'],
    price: '₡65.000',
    before: '₡80.000',
    stock: '30 disponibles',
    note: 'Las firmas se harán exclusivamente en el disco de vinilo oficial.',
    vip: true,
    image: 'https://www.imperioanimecr.com/wp-content/uploads/2026/10/meet-disco-vinyl-1024x1024.jpg',
    href: 'https://www.imperioanimecr.com/p/meet-greet-foto-firma-y-disco-vip/'
  },
  {
    id: 114801,
    name: 'Meet & Greet + Foto, firma + VIP',
    lines: ['Meet & Greet', 'Foto y firma + VIP'],
    price: '₡45.000',
    before: '₡56.000',
    stock: '20 disponibles',
    note: 'Las firmas se harán exclusivamente en el póster oficial.',
    vip: true,
    image: 'https://www.imperioanimecr.com/wp-content/uploads/2026/10/meet-vip-1024x1024.jpg',
    href: 'https://www.imperioanimecr.com/p/meet-greet-foto-firma-vip/'
  },
  {
    id: 114803,
    name: 'Foto y Disco Autografiado',
    price: 'Desde ₡37.000',
    stock: '10 disponibles',
    note: 'Las firmas se harán exclusivamente en el disco de vinilo oficial.',
    detail: 'General ₡37.000 · Platea ₡42.500 · Preferencial ₡50.000',
    image: 'https://www.imperioanimecr.com/wp-content/uploads/2026/10/foto-disco-37000-1024x1024.jpg',
    href: 'https://www.imperioanimecr.com/p/foto-y-disco-autografiado/'
  },
  {
    id: 114802,
    name: 'Foto y Firma (Poster Oficial)',
    price: 'Desde ₡27.000',
    stock: '90 disponibles',
    note: 'Las firmas se harán exclusivamente en el póster oficial.',
    detail: 'General ₡27.000 · Platea ₡32.500 · Preferencial ₡40.000',
    image: 'https://www.imperioanimecr.com/wp-content/uploads/2026/10/foto-firma-1024x1024.jpg',
    href: 'https://www.imperioanimecr.com/p/foto-y-firma-poster-oficial/'
  }
];

const groups = [
  {
    id: 'meet',
    title: 'Meet & Greet + Pase VIP',
    premium: true,
    items: products.filter(product => product.vip)
  },
  {
    id: 'merch',
    title: 'Interacción + Pase',
    items: products.filter(product => !product.vip)
  }
];

const styles = theme => ({
  root: {},
  intro: {
    maxWidth: 680
  },
  group: {
    margin: [32, 'auto', 0],
    maxWidth: 760
  },
  groupTitle: {
    margin: [0, 0, 16],
    paddingBottom: 10,
    fontSize: 18,
    letterSpacing: '0.08em',
    textAlign: 'center',
    borderBottom: `1px solid ${theme.color.background.light}`
  },
  groupVip: {
    '& $groupTitle': {
      color: theme.color.secondary.main,
      borderBottomColor: 'rgba(198,255,58,0.55)',
      textShadow: `0 0 12px ${theme.color.secondary.main}`
    }
  },
  grid: {
    display: 'grid',
    gridTemplateColumns: '1fr 1fr',
    gap: 16,
    margin: 0,
    textAlign: 'left'
  },
  card: {
    margin: 0,
    padding: 12,
    border: `1px solid ${theme.color.background.light}`,
    textAlign: 'center'
  },
  photo: {
    display: 'block',
    width: '100%',
    margin: [0, 0, 12]
  },
  price: {
    margin: [8, 0],
    fontFamily: theme.typography.primary,
    fontSize: 26,
    color: theme.color.secondary.main
  },
  before: {
    display: 'inline-block',
    marginRight: 8,
    color: theme.color.text.main,
    fontSize: 16,
    textDecoration: 'line-through'
  },
  stock: {
    margin: [0, 0, 8],
    fontSize: 13
  },
  note: {
    margin: [0, 0, 12],
    fontSize: 13,
    color: theme.color.secondary.main
  },
  name: {
    margin: [10, 0, 12],
    fontSize: 16,
    lineHeight: 1.35,
    color: theme.color.heading.main,
    textShadow: 'none',

    '& span': {
      display: 'block'
    }
  },
  soon: {
    margin: 0,
    fontFamily: theme.typography.primary,
    fontSize: 13,
    letterSpacing: '0.08em',
    textTransform: 'uppercase',
    color: theme.color.secondary.main
  },
  vip: {
    position: 'relative',
    padding: 16,
    borderColor: theme.color.secondary.main,
    background: 'linear-gradient(180deg, rgba(198,255,58,0.16) 0%, rgba(179,136,255,0.08) 22%, rgba(7,1,15,0.45) 100%)',
    boxShadow: '0 0 22px rgba(198,255,58,0.32), inset 0 0 0 1px rgba(179,136,255,0.7)'
  },
  badge: {
    display: 'inline-block',
    margin: [4, 0, 0],
    padding: [5, 14],
    fontFamily: theme.typography.primary,
    fontSize: 11,
    letterSpacing: '0.24em',
    color: theme.color.background.dark,
    background: theme.color.secondary.main,
    boxShadow: '0 0 12px rgba(198,255,58,0.65)'
  },
  frame: {
    position: 'absolute',
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    width: '100%',
    height: '100%',
    pointerEvents: 'none',
    overflow: 'visible',

    '& rect': {
      fill: 'none',
      stroke: theme.color.secondary.main,
      strokeWidth: 1.5,
      vectorEffect: 'non-scaling-stroke',
      strokeDasharray: '16 84',
      animation: 'arwesTrace 3.6s linear infinite'
    }
  },
  corners: {
    position: 'absolute',
    top: 4,
    right: 4,
    bottom: 4,
    left: 4,
    width: 'calc(100% - 8px)',
    height: 'calc(100% - 8px)',
    pointerEvents: 'none',

    '& path': {
      fill: 'none',
      stroke: theme.color.secondary.light,
      strokeWidth: 2,
      vectorEffect: 'non-scaling-stroke'
    }
  },
  '@global': {
    '@keyframes arwesTrace': {
      to: { strokeDashoffset: -100 }
    }
  }
});

class Tienda extends React.Component {
  static propTypes = {
    classes: PropTypes.object
  };

  render () {
    const { classes } = this.props;

    return (
      <Main className={classes.root}>
        <Secuence stagger>
          <h1><Text>Tienda</Text></h1>
          <p className={classes.intro}>
            <Text>Meet & greet, foto, firma y disco del concierto de Yoko Takahashi en Costa Rica.</Text>
          </p>
          {groups.map(group => (
            <Fader key={group.title}>
              <section id={group.id} className={cx(classes.group, group.premium && classes.groupVip)}>
                <h2 className={classes.groupTitle}><Text>{group.title}</Text></h2>
                <div className={classes.grid}>
                  {group.items.map(product => (
                    <article key={product.id} className={cx(classes.card, product.vip && classes.vip)}>
                      {product.vip && (
                        <svg className={classes.frame} viewBox='0 0 100 100' preserveAspectRatio='none' aria-hidden='true'>
                          <rect x='1' y='1' width='98' height='98' pathLength='100' />
                        </svg>
                      )}
                      {product.vip && (
                        <svg className={classes.corners} viewBox='0 0 100 100' preserveAspectRatio='none' aria-hidden='true'>
                          <path d='M1 16 V1 H16' />
                          <path d='M84 1 H99 V16' />
                          <path d='M99 84 V99 H84' />
                          <path d='M16 99 H1 V84' />
                        </svg>
                      )}
                      <img className={classes.photo} src={product.image} alt={product.name} />
                      {product.vip && <p className={classes.badge}>PASE VIP</p>}
                      <h2 className={classes.name}>
                        {product.lines
                          ? product.lines.map(line => <span key={line}>{line}</span>)
                          : product.name}
                      </h2>
                      <p className={classes.price}>
                        {product.before && <span className={classes.before}>{product.before}</span>}
                        {product.price}
                      </p>
                      {product.detail && <p className={classes.stock}>{product.detail}</p>}
                      <p className={classes.stock}>{product.stock}</p>
                      <p className={classes.note}>{product.note}</p>
                      <p className={classes.soon}>Próximamente</p>
                    </article>
                  ))}
                </div>
              </section>
            </Fader>
          ))}
        </Secuence>
      </Main>
    );
  }
}

export default withStyles(styles)(Tienda);
